import React, { useCallback } from "react";
import { Box, Grid, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { FileVisualizer } from "ui/componentes/FileVisualizer";
import { BucketFolders } from "api/constants";
import { FieldArray, useFormikContext } from "formik";
import { Track } from "api/model/Track";
import { useDeleteFile } from "api/hooks/useDeleteFile";

const TrackCoursesFormList = () => {
    const { submitForm, values } = useFormikContext<Track>();
    const onDeleteFile = useCallback(() => submitForm(), [submitForm]);
    const deleteFile = useDeleteFile();
    const onDeleteTrackCourse = useCallback(
        (course, remove, index) => () => {
            if (course.image) {
                deleteFile(course.image).then(() => {
                    remove(index);
                    submitForm();
                });
            } else {
                remove(index);
                submitForm();
            }
        },
        [deleteFile, submitForm]
    );

    return (
        <FieldArray name="courses">
            {({ remove }) => {
                return (
                    <Grid container spacing={1}>
                        {values.courses?.map((course, index) => (
                            <Grid key={`${index}_course`} item xs={12}>
                                <Box display="flex" flexDirection="column">
                                    <FileVisualizer
                                        label={course.name}
                                        file={course.image}
                                        uploadProps={{
                                            name: `courses.${index}.image`,
                                            accept: "image/*",
                                            folder: BucketFolders.TRACKS,
                                            disabled: !values.id,
                                            onComplete: () => submitForm(),
                                        }}
                                        onDelete={onDeleteFile}
                                    />
                                    <IconButton
                                        edge="end"
                                        aria-label="remove"
                                        color="secondary"
                                        title={`Deletar traçado ${course.name}`}
                                        style={{ alignSelf: "flex-end" }}
                                        onClick={onDeleteTrackCourse(
                                            course,
                                            remove,
                                            index
                                        )}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                );
            }}
        </FieldArray>
    );
};

export { TrackCoursesFormList };
